<div class="calendar-card" [class.fullscreen-mode]="fullscreen">
  <!-- HEADER SECTION -->
  <div class="calendar-header">
    <h4 class="m-0">
      Project Timeline (Total: {{ totalWeeks }} weeks)
      <small class="text-muted ms-2" *ngIf="firstStepDate && lastStepDate">
        {{ formatLongDate(firstStepDate) }} to {{ formatLongDate(lastStepDate) }}
      </small>
    </h4>
    <button class="btn btn-sm" (click)="fullscreen = !fullscreen"  [pTooltip]="fullscreen ? 'Collapse' : 'Expand'"  tooltipPosition="bottom">
      <i class="pi pi-window-maximize"></i>
    </button>
  </div>

  <!-- Week Header -->
  <div class="week-header-container">
    <div class="step-name-header">Steps</div>
    <div class="week-header-scroll" #weekHeader>
      <div class="week-header-grid" [style.width]="getWeekCellsContainerWidth()">
        <div *ngFor="let week of allWeeks; let i = index" class="week-header-cell"
          [class.current-week]="isCurrentWeek(week)">
          <div class="week-number">Week {{ i + 1 }}</div>
          <div class="week-dates">{{ formatShortDate(week.startDate) }} - {{ formatShortDate(week.endDate) }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Timeline Content -->
  <div class="timeline-body-wrapper" #timelineScroll (scroll)="onTimelineScroll()">
    <div class="timeline-grid" [style.width]="getWeekCellsContainerWidthWithStepList()">
      <!-- Steps -->
      <div *ngFor="let step of steps; let i = index" class="step-row">
        <!-- Fixed Step Name Column -->
        <div class="step-name-cell">
          <div class="step-name">{{ i + 1 }}. {{ step.name }}</div>
          <div class="step-duration">{{ step.week_timeline }} week(s)</div>
        </div>

        <!-- Scrollable Timeline -->
        <div class="step-timeline-cells">
          <div *ngFor="let week of allWeeks" class="week-cell" [class.active-week]="isStepActiveInWeek(step, week)"
            [class.current-week]="isCurrentWeek(week)"></div>

          <!-- Step Event Bar -->
          <!-- Modify the step-event-bar div to include status and use the new styling -->
          <div class="step-event-bar" [ngStyle]="getStepStatusStyle(step)" [style.left.px]="getStepLeftOffset(step)"
            [style.width.px]="getStepWidth(step)" (mouseenter)="setHoverStep(step.id)"
     (mouseleave)="setHoverStep(null)">
            <div class="step-event-label">
              <div>{{ step.name }}</div>
              <div class="step-status">{{ getStepStatusText(step) }}</div>
              <div class="step-status" *ngIf="step.latest_log?.remark">Remark as on {{today | date: 'dd MMM yyyy'}} - {{
                step.latest_log?.remark }} ({{ formatShortDate(step.latest_log?.timestamp) }})</div>
              <div class="step-dates"> Timeline -
                {{ formatShortDate(step.created_on) }} -
                {{ formatShortDate(getStepEndDate(step)) }}
              </div>
            </div>
            <!-- Add this inside your step-event-bar div -->
            <div class="step-hover-card" *ngIf="hoveredStep === step.id">
              <div class="hover-card-header">
                <h5>{{ step.name }}</h5>
                <div class="step-status-badge black" [ngClass]="'status-' + step.status">
                  {{ getStepStatusText(step) }}
                </div>
              </div>
              <div class="hover-card-content">
                <div class="info-row">
                  <span class="info-label">Timeline:</span>
                  <span>{{ formatShortDate(step.created_on) }} - {{ formatShortDate(getStepEndDate(step)) }}</span>
                </div>
                <div class="info-row" *ngIf="step.latest_log?.remark">
                  <span class="info-label">Remark ({{ formatShortDate(step.latest_log?.timestamp) }}):</span>
                  <span>{{ step.latest_log?.remark }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Duration:</span>
                  <span>{{ step.week_timeline }} week(s)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>